export default __webpack_public_path__ + "static/media/about-bg-smd.97cde3d7.svg";